import { RoutePath } from "src/data/Routes";
import { API_URL } from "../../../data/Api";
import { GLOB } from "../../../util/Glob";
import { ContextState, FolderContextMenuBase, MenuDataNode } from '../FolderContextMenuBase';

export type { ContextState, MenuDataNode };

export class CustomFolderContextMenu extends FolderContextMenuBase {

  constructor(
    getState: () => ContextState,
    setState: (state: ContextState) => void,
    onDelete?: (item: MenuDataNode) => void,
    isNavMenu = false
  ) {
    super({
      getState,
      setState,
      onDelete,
      isNavMenu,
      createUrl: `${API_URL.CUSTOM_GROUP}/folders`,
      getIdFromResponse: d => d.custom_group_folder_id,
      getItemDataUrl: id => `${API_URL.CUSTOM_GROUP}/folders/${id}`,
      getItemMenuUrl: id => `${API_URL.CUSTOM_GROUP}/menu/folder/${id}`,
      renameUrl: id => `${API_URL.CUSTOM_GROUP}/folders/${id}`,
      deleteUrl: id => `${API_URL.CUSTOM_GROUP}/folders/${id}`,
      reload: () => GLOB.menuService.reloadCustomGroups(),
      deleteContentLabel: 'custom groups',
      linkRoute: RoutePath.SETTINGS + RoutePath.CONFIGURATION + RoutePath.SET_CG,
    });
  }
}
